// Generated by CoffeeScript 1.11.1
(function() {
  var Descriptor, PathSelection;

  Descriptor = require('../descriptor');

  module.exports = PathSelection = (function() {
    PathSelection.prototype.id = 1088;

    PathSelection.prototype.name = 'pathSelection';

    function PathSelection(resource) {
      this.resource = resource;
      this.file = this.resource.file;
    }

    PathSelection.prototype.parse = function() {
      this.file.seek(4, true);
      return this.data = new Descriptor(this.file).parse();
    };

    return PathSelection;

  })();

}).call(this);
